export var SortDirections;
(function (SortDirections) {
    SortDirections["Ascending"] = "asc";
    SortDirections["Descending"] = "desc";
})(SortDirections || (SortDirections = {}));
//# sourceMappingURL=sort-directions.js.map